export interface Service {
  title: string;
  description: string;
  icon: string;
}

export const services: Service[] = [
  {
    title: "Révision avant livraison",
    description: "Vidange, distribution, pompe à eau… selon les besoins du véhicule.",
    icon: "ri-tools-line",
  },
  {
    title: "Contrôle technique",
    description: "Contrôle technique de moins de 6 mois.",
    icon: "ri-shield-check-line",
  },
  {
    title: "Financement",
    description: "Accompagnement pour constituer votre dossier de crédit.",
    icon: "ri-bank-card-line",
  },
  {
    title: "Garantie commerciale",
    description: "Garantie allant de 3 à 12 mois selon le véhicule.",
    icon: "ri-award-line",
  },
  {
    title: "Carte grise",
    description: "Accompagnement pour le transfert de la carte grise.",
    icon: "ri-file-list-3-line",
  },
  {
    title: "Reprise",
    description: "Possibilité de reprise de votre ancien véhicule.",
    icon: "ri-exchange-line",
  },
];